import { images } from "@/data/resort";
import { ResortLink } from "../resort-button";
import { Eyebrow, MaskReveal, Reveal } from "../reveal";

export function PetFriendly() {
  return (
    <section
      id="pets"
      aria-labelledby="pets-heading"
      className="scroll-mt-16 bg-background py-16 md:py-20"
    >
      <div className="shell">
        <div className="grid items-center gap-8 lg:grid-cols-12 lg:gap-10">
          <Reveal className="order-1 lg:col-span-6 lg:order-none" y={36}>
            <img
              src={images.amenityPets}
              alt="Fenced dog park for pet-friendly stays at Auburn RV Resort"
              width={1400}
              height={1600}
              loading="lazy"
              decoding="async"
              className="aspect-[4/5] w-full object-cover md:aspect-[5/6]"
            />
          </Reveal>

          <div className="order-2 lg:col-span-6 lg:order-none">
            <Reveal>
              <Eyebrow>Four-Legged Travelers Welcome</Eyebrow>
            </Reveal>
            <h2 id="pets-heading" className="display-lg mt-6 max-w-[16ch]">
              <MaskReveal>Adventure Is Better</MaskReveal>
              <MaskReveal delay={0.08}>With Your Best Friend</MaskReveal>
            </h2>
            <Reveal delay={0.1}>
              <p className="mt-8 max-w-xl text-base leading-relaxed text-muted-foreground">
                Auburn RV Resort is pet friendly and includes a fenced dog park where your
                four-legged travel companion can enjoy some off-leash time. A convenient dog wash
                station also makes cleaning up after an outdoor adventure easier.
              </p>
            </Reveal>

            <Reveal delay={0.16}>
              <div className="mt-10 grid gap-4 sm:grid-cols-2">
                <article className="border border-border bg-secondary/30 p-6">
                  <h3 className="eyebrow text-primary">Fenced Dog Park</h3>
                  <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
                    A secure dedicated area for your dog to stretch and enjoy time outside.
                  </p>
                </article>
                <article className="border border-border bg-secondary/30 p-6">
                  <h3 className="eyebrow text-primary">Dog Wash Station</h3>
                  <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
                    A convenient place to clean up after trails, travel and outdoor adventures.
                  </p>
                </article>
              </div>
            </Reveal>

            <Reveal delay={0.2}>
              <ResortLink variant="gold" href="/reservations/" className="mt-10 w-full sm:w-auto">
                Check Pet-Friendly Availability
              </ResortLink>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
